import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const Users = lazy(() => import("@/pages/Users/Users"));
const UsersData = lazy(() => import("@/pages/Users/components/UsersData/UsersData"));
const AddUser = lazy(() => import("@/pages/Users/components/AddUser/AddUser"));
const ViewNEditUser = lazy(() => import("@/pages/Users/components/ViewNEditUser/ViewNEditUser"));
const BulkUploadUser = lazy(() => import("@/pages/Users/components/BulkUpload/BulkUpload"));
const BulkUploadReport = lazy(() => import("@/pages/Users/components/BulkReport/BulkReport"));
const UsersBulkReportView = lazy(() => import("@/pages/Users/components/BulkReport/UsersBulkReportView"));
const AuditLog = lazy(() => import("@/pages/Users/components/AuditLog/AuditLog"));

const UsersRoute: RouteConfig = {
    path: "users",
    element: <Users />,
    pageName: "All Users",
    sidebar: { show: true, icon: "" },
    permission: ["AllUsersData"],
    children: {
        USER_DATA: {
            path: "",
            element: <UsersData />,
            pageName: "Users",
        },
        ADD_USER: {
            path: "addUser",
            element: <AddUser />,
            pageName: "Users"
        },
        EDIT_USER: {
            path: "editUser",
            element: <ViewNEditUser />,
            pageName: "Users"
        },
        BULK_UPLOAD: {
            path: "bulk-upload",
            element: <BulkUploadUser />,
            pageName: "Users",
            sidebar: {
                show: false,
                icon: "",
            },
        },
        BULK_REPORTS: {
            path: "bulk-report",
            element: <BulkUploadReport />,
            pageName: "Users",
            sidebar: {
                show: false,
                icon: "",
            },
        },
        BULK_REPORT_VIEW: {
            path: "bulk-upload/view-report/:id",
            element: <UsersBulkReportView />,
            pageName: "Users",
            sidebar: {
                show: false,
                icon: "",
            },
        },
        AUDIT_LOG: {
            path: "audit-log",
            element: <AuditLog/>,
            permission: ["ViewAuditLogs"],
            pageName: "User Audit Log",
            sidebar: {
                show: false,
                icon: "",
            }
        }
    }
};

export default UsersRoute;